import { Box } from '@mui/material';

import { GenericEntityHeader } from './GenericEntityHeader';
import { EntityType, MergeableEntity, MergeEntityData } from './types';
import { GenericEntityDataAccordions } from './GenericEntityDataAccordions';

interface GenericEntitySectionProps {
  entity: MergeableEntity;
  entityType: EntityType;
  data?: MergeEntityData;
  isSelected: boolean;
  onRadioChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onLoadMore: (entityId: number, dataType: string) => void;
}

export const GenericEntitySection = ({
  entity,
  entityType,
  data,
  isSelected,
  onRadioChange,
  onLoadMore,
}: GenericEntitySectionProps) => (
  <Box key={entity.id} sx={{ flex: 1, border: 1, borderColor: 'divider', borderRadius: 1, p: 2 }}>
    <GenericEntityHeader
      entity={entity}
      entityType={entityType}
      isSelected={isSelected}
      onRadioChange={onRadioChange}
    />
    {data && (
      <GenericEntityDataAccordions
        data={data}
        entityId={entity.id}
        entityType={entityType}
        onLoadMore={onLoadMore}
      />
    )}
  </Box>
);
